module.exports = __webpack_public_path__ + "static/media/covi_ppe_nec_gai.7eed3496.png";